<template>
   <v-hover>
      <v-card slot-scope="{hover}" :class="`elevation-${hover ? 15 : 5} pa-2 border-primary`">
        <v-layout row wrap align-center>
          <v-flex xl4 lg12 md4 sm4 xs3>
            <v-img
              :src="tramite.imagen"
              height="100px"
              contain
              v-if="tramite.imagen"
            ></v-img>
          </v-flex>
          <v-flex xl8 lg12 md8 sm8 xs9>
            <v-card-text>
              <div class="subheading font-weight-bold primary--text pb-3 text-xs-left" v-text="tramite.titulo"></div>
              <div class="body-1 text-xs-justify " v-html="tramite.descripcion"></div>
              <slot name="contador"></slot>
            </v-card-text>
            <v-card-actions v-if="tramite.acciones">
              <v-spacer></v-spacer>
              <slot name="accionesTramite"></slot>
            </v-card-actions>
          </v-flex>
        </v-layout>
      </v-card>
    </v-hover>
</template>
<script>
export default {
    props:{
        tramite:{
            type:Object,
            default:{
                imagen:null,
                titulo:'TRAMITE RPA',
                descripcion:'Descripcion del Tramite',
                acciones:true
            }
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/components/Inicio/Tramite.vue